// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      headerTitle: 'PanOncology Trials',
      searchPlaceholder: 'Search and filter our clinical trials.',
      contactButton: 'Contact about this trial',
      backButton: 'Back to list',
      privacyPolicy: 'Privacy policy',
      all: 'All',
      organSystem: 'Organ System',
      location: 'Location',
      keyword: 'Keyword',
      noTrialsFound: 'No trials found.',
      clear: 'Clear',
      loadingTrialDetails: 'Loading trial details...',
      trialNotFound: 'Trial not found',
      nct: 'NCT',
      otherId: 'Other ID',
      leadSponsor: 'Lead Sponsor',
      cancerStage: 'Cancer Stage',
      biomarker: 'Biomarker',
      conditions: 'Conditions',
      officialTitle: 'Official Title',
      locations: 'Locations',
      moreInformation: 'More Information',
      unknown: 'Unknown',
      treatment: 'Treatment',
      therapyLine: 'Therapy Line',	

      // Traducciones específicas para el modal de contacto:
      contactTitle: 'Contact us',
      studyCodeLabel: 'Study Code',
      nameLabel: 'Name',
      emailLabel: 'Email',
      messageLabel: 'Message',
      cancel: 'Cancel',
      send: 'Send',

      studyTitleLabel: 'Study Title',
      loadingTrialList: 'Loading clinical trials...',

      locationNotice: 'Not seeing your city? You can still request info about any trial.',
    },
  },
  es: {
    translation: {
      headerTitle: 'PanOncology Ensayos Clínicos',
      searchPlaceholder: 'Busca y filtra nuestros ensayos clínicos.',
      contactButton: 'Contactar sobre este ensayo',
      backButton: 'Volver a la lista',
      privacyPolicy: 'Política de privacidad',
      all: 'Todos',
      organSystem: 'Sistema de Órganos',
      location: 'Ubicación',
      keyword: 'Palabra clave',
      noTrialsFound: 'No se encontraron ensayos.',
      clear: 'Limpiar',
      loadingTrialDetails: 'Cargando detalles del ensayo...',
      trialNotFound: 'Ensayo no encontrado',
      nct: 'NCT',
      otherId: 'Otro ID',
      leadSponsor: 'Patrocinador Principal',
      cancerStage: 'Etapa del Cáncer',
      biomarker: 'Biomarcador',
      conditions: 'Condiciones',
      officialTitle: 'Título Oficial',
      locations: 'Ubicaciones',
      moreInformation: 'Más Información',
      unknown: 'Desconocido',
      treatment: 'Tratamiento',
      therapyLine: 'Línea de Terapia',

      // Traducciones específicas para el modal de contacto:
      contactTitle: 'Contáctanos',
      studyCodeLabel: 'Código de Estudio',
      nameLabel: 'Nombre',
      emailLabel: 'Correo electrónico',
      messageLabel: 'Mensaje',
      cancel: 'Cancelar',
      send: 'Enviar',

      studyTitleLabel: 'Título del Estudio',
      loadingTrialList: 'Cargando ensayos clínicos...',
      locationNotice: 'Si tu ubicación no está en la lista, aún puedes solicitar información sobre cualquier ensayo.',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // Idioma por defecto
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React ya protege contra XSS
  },
});

export default i18n;
